export enum E_BINANCE_VIP_CONSENT_PERMISSIONS {
  isTermsAccepted = 'isTermsAccepted',
  isRiskAccepted = 'isRiskAccepted',
  isNdaAccepted = 'isNdaAccepted',
}

export interface IBinanceVipConsentForm {
  permissions: E_BINANCE_VIP_CONSENT_PERMISSIONS[]
}
